import CardFrame from "../../assets/card-frame-web.png";
import BlindBox from "../../assets/questionball_frame.png";
import Claim from "./Claim";

export default function ClaimConfigsPage(){
    return(
        <Claim style={style} />
    )
}

const style = {
    button:{
        backgroundColor: '#281EC8',
        color: '#ffffff',
        content:{
            text: '立即领取'
        }
    },
    frame:{
        height: '356px',
        width: '293px',
        backgroundImage: CardFrame,
        contentImage: BlindBox,
        content:{
            height: '207px',
            width: '234px'
        }
    },
    background:{
        marginTop: '0px'
    },
    backIcon:{
        padding: '16px 0 0 16px'
    }
};